import { render } from "./Video.vue?vue&type=template&id=16545eba"
import script from "./Video.js?vue&type=script&lang=js"
export * from "./Video.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__